<template>
    <div>
    <div class="loader" v-if="this.isLoading"></div>
      <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
      <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
        <!--begin::sidebar-->
        <navbar-component></navbar-component>
        <!--end::sidebar-->
  
        <div class="page-wrapper">
          <!--begin::navbar-->
         
          <!--end::navbar-->
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                        <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">Excel to Textfile Converter</h6>


                        <!-- <button
                          class="btn btn-success btn-xs float-end"
                          @click="downloadData"
                          type="button"
                        > -->
                        <!-- <i class="link-icon" data-feather="download"></i>
                          {{ $t("downloadData") }} Template
                        </button>
   -->
                 
                  </div>
                  <div class="card-body">
                    <!--begin::loading-data-->
                    <!-- <div v-if="isLoading" class="d-flex align-items-center">
                      <div
                        class="spinner-border ms-auto"
                        role="status"
                        aria-hidden="true"
                      ></div>
                      <strong>{{ $t("loadingTxt") }}...</strong>
                    </div> -->
                    <!--end::loading-data-->
  
                    <form
                      class="forms-sample"
                      @submit.prevent="submitData"
                      method="POST"
                      enctype="multipart/form-data"
                    >
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-baseline
                          mb-2
                        "
                      >
                      
                      </div>
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">File</label>
                        </div>
                        <div class="col-lg-8">
                         
                          <input type="file" ref="file" class="form-control" @change="handleFileUpload($event)" />
  
                          <div v-if="errors.code">
                            <div
                              v-for="error in errors.code"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Type</label>
                        </div>
                        <div class="col-lg-8">
                         
                            <v-select :options="fetchType" v-model="typeBca" label="name" return-object
                              >
                              <template slot="option" slot-scope="option">
                                {{ option.name }}
                              </template>
                            </v-select>

                         
                        </div>
                      </div>
                      
  
                      
                      <div class="row mb-3" v-if="tableError">
                        <div class="col-lg-2">
                        </div>
                        <div class="col-lg-8">
                        <div class="table-responsive">
                          <!-- <table class="table table-hover">
                            <thead>
                              <th>{{ $t('lineNo') }}</th>
                              <th>{{ $t('statusTxt') }}</th>
                              <th>{{ $t('messageTxt') }}</th>
                            </thead>
                            <tbody>
                              <tr v-for="(errorsData, index) in errorsData" :key="index">
                                <th>{{ errorsData.rowNo }}</th>
                                <th>{{ errorsData.status }}</th>
                                <th>{{ errorsData.message }}</th>
                              </tr>
                            </tbody>
                          </table> -->
                          </div>
                        </div>
  
  
                      </div>
  
  
  
  
  
                     
                      <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
  
                        &nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-primary float-end btn-sm"
                          type="submit"
                        >
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                      </div>
  
                    </form>
                  </div>
                </div> <!--end::card-->
              </div>
            </div>



            <br>

            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                        <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">Generate SA</h6>


                        <!-- <button
                          class="btn btn-success btn-xs float-end"
                          @click="downloadData"
                          type="button"
                        > -->
                        <!-- <i class="link-icon" data-feather="download"></i>
                          {{ $t("downloadData") }} Template
                        </button>
   -->
                 
                  </div>
                  <div class="card-body">
                    <!--begin::loading-data-->
                    <!-- <div v-if="isLoading" class="d-flex align-items-center">
                      <div
                        class="spinner-border ms-auto"
                        role="status"
                        aria-hidden="true"
                      ></div>
                      <strong>{{ $t("loadingTxt") }}...</strong>
                    </div> -->
                    <!--end::loading-data-->
  
                    <form
                      class="forms-sample"
                      @submit.prevent="submitDataAddjustment"
                      method="POST"
                      enctype="multipart/form-data"
                    >
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-baseline
                          mb-2
                        "
                      >
                      
                      </div>
                      
                     


                      <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Start Date</label>
                        </div>
                        <div class="col-lg-3">
                            
                            <date-range-picker style="width: 100%" control-container-class="form-control"
                              :locale-data="locale" v-model="dateFilterStart" :opens="opens" :singleDatePicker="true"
                              :timePicker24Hour="true" :timePicker="true" :showWeekNumbers="false">
                            </date-range-picker>
                          
                         
                        </div>

                        <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">End Date</label>
                        </div>
                        <div class="col-lg-3">
                            
                            <date-range-picker style="width: 100%" control-container-class="form-control"
                              :locale-data="locale" v-model="dateFilterEnd" :opens="opens" :singleDatePicker="true"
                              :timePicker24Hour="true" :timePicker="true" :showWeekNumbers="false">
                            </date-range-picker>
                          
                         
                        </div>
                      </div>
                      
  
                      
                      <div class="row mb-3" v-if="tableError">
                        <div class="col-lg-2">
                        </div>
                        <div class="col-lg-8">
                        <div class="table-responsive">
                          <!-- <table class="table table-hover">
                            <thead>
                              <th>{{ $t('lineNo') }}</th>
                              <th>{{ $t('statusTxt') }}</th>
                              <th>{{ $t('messageTxt') }}</th>
                            </thead>
                            <tbody>
                              <tr v-for="(errorsData, index) in errorsData" :key="index">
                                <th>{{ errorsData.rowNo }}</th>
                                <th>{{ errorsData.status }}</th>
                                <th>{{ errorsData.message }}</th>
                              </tr>
                            </tbody>
                          </table> -->
                          </div>
                        </div>
  
  
                      </div>
  
  
  
  
  
                     
                      <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
  
                        &nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-primary float-end btn-sm"
                          type="submit"
                        >
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                      </div>
  
                    </form>
                  </div>
                </div> <!--end::card-->
              </div>
            </div>
            
            <br>

            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                        <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">Upload Text SO</h6>


                        <!-- <button
                          class="btn btn-success btn-xs float-end"
                          @click="downloadData"
                          type="button"
                        > -->
                        <!-- <i class="link-icon" data-feather="download"></i>
                          {{ $t("downloadData") }} Template
                        </button>
   -->
                 
                  </div>
                  <div class="card-body">
                    <!--begin::loading-data-->
                    <!-- <div v-if="isLoading" class="d-flex align-items-center">
                      <div
                        class="spinner-border ms-auto"
                        role="status"
                        aria-hidden="true"
                      ></div>
                      <strong>{{ $t("loadingTxt") }}...</strong>
                    </div> -->
                    <!--end::loading-data-->
  
                    <form
                      class="forms-sample"
                      @submit.prevent="submitDataUploadTextSo"
                      method="POST"
                      enctype="multipart/form-data"
                    >
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-baseline
                          mb-2
                        "
                      >
                      
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label"  style="padding-left: 25px">Warehouse Id</label>
                          </div>
                          <div class="col-lg-8">
                            <v-select :options="fetchFulfillment" v-model="fulfillment" label="code" return-object
                              @search="asyncSearchFulfillment">
                              <template slot="option" slot-scope="option">
                                {{ option.code }} | {{ option.name }}
                              </template>
                            </v-select>


                            <div v-if="errors.fulfillment_center_id">
                              <div v-for="error in errors.fulfillment_center_id" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">File</label>
                        </div>
                        <div class="col-lg-8">
                         
                          <input type="file" ref="file" class="form-control" @change="handleFileUpload($event)" />
  
                          <div v-if="errors.code">
                            <div
                              v-for="error in errors.code"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                  
                      
  
                      
                      <div class="row mb-3" v-if="uploadTextSoResult">
                        <div class="col-lg-2">
                        </div>
                        <div class="col-lg-8">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                              <th>Order No </th>
                            </thead>
                            <tbody>
                              <tr v-for="(data, index) in uploadTextSoResponse" :key="index">
                                <th>{{ data }}</th>
                              </tr>
                            </tbody>
                          </table>
                          </div>
                        </div>
  
  
                      </div>
  
  
  
  
  
                     
                      <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
  
                        &nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-primary float-end btn-sm"
                          type="submit"
                        >
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                      </div>
  
                    </form>
                  </div>
                </div> <!--end::card-->
              </div>
            </div>

            <br>
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">Upload Text PO</h6>
                  </div>
                  <div class="card-body">  
                    <form
                      class="forms-sample"
                      @submit.prevent="submitDataUploadTextPo"
                      method="POST"
                      enctype="multipart/form-data"
                    >
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-baseline
                          mb-2
                        "
                      >
                      
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label"  style="padding-left: 25px">Warehouse Id</label>
                          </div>
                          <div class="col-lg-8">
                            <v-select :options="fetchFulfillment" v-model="fulfillmentPo" label="code" return-object
                              @search="asyncSearchFulfillment">
                              <template slot="option" slot-scope="option">
                                {{ option.code }} | {{ option.name }}
                              </template>
                            </v-select>


                            <div v-if="errors.fulfillment_center_id">
                              <div v-for="error in errors.fulfillment_center_id" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">File</label>
                        </div>
                        <div class="col-lg-8">
                         
                          <input type="file" ref="file" class="form-control" @change="handleFileUpload($event)" />
  
                          <div v-if="errors.code">
                            <div
                              v-for="error in errors.code"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                  
                      
  
                      
                      <div class="row mb-3" v-if="uploadTextPoResult">
                        <div class="col-lg-2">
                        </div>
                        <div class="col-lg-8">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                              <th>Order No </th>
                            </thead>
                            <tbody>
                              <tr v-for="(data, index) in uploadTextPoResponse" :key="index">
                                <th>{{ data }}</th>
                              </tr>
                            </tbody>
                          </table>
                          </div>
                        </div>
  
  
                      </div>
  
  
  
  
  
                     
                      <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
  
                        &nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-primary float-end btn-sm"
                          type="submit"
                        >
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                      </div>
  
                    </form>
                  </div>
                </div> <!--end::card-->
              </div>
            </div>

          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  import DateRangePicker from "vue2-daterange-picker";
  
  export default {
    name: "SOUpload",
    props: {},
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
      DateRangePicker
    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

      return {
        tableError:false,
        uploadTextSoResult:false,
        uploadTextSoResponse:[],
        errorsData:[],
        file: '',
        permision_role:[],
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        dateFilterStart: {
            startDate,
            endDate,
        },
        dateFilterEnd: {
            startDate,
            endDate,
        },
        opens: "center",
        locale: {
            format: "yyyy-mm-dd",
        },

        localeDetail: {
            format: "yyyy-mm-dd",
        },

        highlighted: {

            dates: [ // Highlight an array of dates
            new Date(),
            ],

        },
        typeBca:'',
        fetchType:[
            {
                name:'GI'
            },
            {
                name:'GR'
            },
            {
                name:'SR'
            }
        ],
        userData: "",
        regionCode: "",
        forms: { name: "", usernmae: "" },
        fetchFulfillment:[],
        fulfillment:null,
        fulfillmentPo:null,
        uploadTextPoResult:false,
        uploadTextPoResponse:[],
      };
    },
    watch: {},
    methods: {
      loadFullfilment() {
        const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

        return this.$http
          .get(
            baseURI, { timeout: 10000 }
          )
          .then((response) => {
            this.fetchFulfillment = response.data.datas.data;
          }).catch(error => {
            if (error.code == "ECONNABORTED") {
              this.error("Please Check Your Internet Connection");
            }
        });
      },
      asyncSearchFulfillment(ev) {
      this.fetchFulfillment = [];
      const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment?code=" + ev;

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
          //console.log(this.fetchFulfillment);
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },
      resetForm() {
  
  
      },
  
  
      handleFileUpload( event ){
        this.file = event.target.files[0];
      },
  
      downloadData() {
        const baseURI = this.$settings.endPointFluxOms + "v2/asn/download-template-order";
  
        var file_name = "template_asn.xlsx";
  
        //var columnFilters = this.serverParams.columnFilters;
  
  
        return this.$http
          .get(
            baseURI,
            {
              responseType: "blob",
            }
          )
          .then((response) => {
           
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
      },
  
  
      fetchIt() {
        const userDatas = this.$getUserInfo();
        this.detailUser = userDatas.sub;
        // this.permision_role = userDatas.sub.permision_role;
        let rolePermision = [];
        userDatas.sub.permision_role.forEach(function (permision) {
          if (permision.permission.controller == 'InterfaceBcaController') {
            rolePermision = permision;
          }
        });
  
        if (!rolePermision.method_read) {
          this.$router.push("/authorized-error");
        }
        this.permision_role = rolePermision;
  
      },

      backForm() {
         window.location.href = "/flux-oms/asn-inbound";
      },
  
  
      submitData() {
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourData"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            this.fade(true);
  
            let formData = new FormData();
            // console.log(this.file);
            formData.append("type", this.typeBca.name);
            formData.append("file", this.file);
           
            const baseURI  =  this.$settings.endPointFluxOms+"v2/interface/bca/convert-file";
            this.$http.post(baseURI,formData, {
              responseType: "blob",
            }).then((response) => {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                const fileName = response.headers['filename'];

                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                this.fade(false);


            }).catch(error => {
                // console.log(error);
                this.loading();
                // if (error.response) {
                // if(error.response.status === 422) {
                //         this.errors = error.response.data.errors;
                //         this.resultError(error.response.data.errors);
                // }else if (error.response.status === 500) {
                //     this.$router.push('/server-error');
                // }else{
                //     this.$router.push('/page-not-found');
                // }
                // }
                // this.resetForm();
                this.tableError=true;
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errorsData = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

                
            });
          }
        });
      },


      submitDataUploadTextSo() {
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourData"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            this.fade(true);
  
            let formData = new FormData();
            // console.log(this.file);
            formData.append("fulfillment_center_id",this.fulfillment?.fulfillment_center_id ? this.fulfillment?.fulfillment_center_id : "");
            formData.append("file", this.file);
           
            const baseURI  =  this.$settings.endPointFluxOms+"v2/interface/bca/upload-file-so";
            this.$http.post(baseURI,formData).then((response) => {
              this.success("Upload Success ");
              this.uploadTextSoResponse = response.data.datas;
              this.uploadTextSoResult = true;
                this.fade(false);


            }).catch(error => {
                // console.log(error);
                this.loading();
                this.tableError=true;
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errorsData = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

                
            });
          }
        });
      },


      submitDataUploadTextPo() {
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourData"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            this.fade(true);
  
            let formData = new FormData();
            // console.log(this.file);
            formData.append("fulfillment_center_id",this.fulfillmentPo?.fulfillment_center_id ? this.fulfillmentPo?.fulfillment_center_id : "");
            formData.append("file", this.file);
           
            const baseURI  =  this.$settings.endPointFluxOms+"v2/interface/bca/upload-file-po";
            this.$http.post(baseURI,formData).then((response) => {
              this.success("Upload Success ");
              this.uploadTextPoResponse = response.data.datas;
              this.uploadTextPoResult = true;
                this.fade(false);


            }).catch(error => {
                // console.log(error);
                this.loading();
                this.tableError=true;
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errorsData = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

                
            });
          }
        });
      },


      submitDataAddjustment() {
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourData"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            this.fade(true);

            // this.forms.poCreationTime = this.$moment(String(this.dateFilter.startDate)).format('YYYY-MM-DD HH:mm:ss');
  
            var data={
                start_date:this.$moment(String(this.dateFilterStart.startDate)).format('YYYY-MM-DD'),
                end_date:this.$moment(String(this.dateFilterEnd.startDate)).format('YYYY-MM-DD'),
            }
           
            const baseURI  =  this.$settings.endPointFluxOms+"v2/interface/bca/addjustment";
            this.$http.post(baseURI,data).then((response) => {
                var file_name = "BCASA.txt";
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);


            }).catch(error => {
                // console.log(error);
                this.loading();
                // if (error.response) {
                // if(error.response.status === 422) {
                //         this.errors = error.response.data.errors;
                //         this.resultError(error.response.data.errors);
                // }else if (error.response.status === 500) {
                //     this.$router.push('/server-error');
                // }else{
                //     this.$router.push('/page-not-found');
                // }
                // }
                // this.resetForm();
                this.tableError=true;
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errorsData = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

                
            });
          }
        });
      },
  
      fade(sType) {
        this.isLoading = sType;
      },
  
      loading() {
        this.fade(true);
        setTimeout(() => {
          this.fade(false);
        }, 1000); // hide the message after 3 seconds
      },
  
      resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
          }
        }
      },
  
      success(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "success",
          title: kata,
        });
      },
  
      error(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: kata,
        });
      },
    },
    events: {},
    created: function () {},
    mounted() {
      this.loadFullfilment();
      this.fetchIt();
    },
  };
  </script>
  <style scoped>
  </style>